import { provider } from "@/provider.js"
import Helpers from "@/helpers.js"

export default {
  setCurrentFolderSelection({ commit }, { folder, selected }) {
    if (selected && folder) {
      commit('setCurrentFolderSelection', folder)
    } else {
      commit('setCurrentFolderSelection', null)
    }
  },
  setCurrentFolderPath({ commit }, { folderPath, dialogDocumentsTable }) {
    if (folderPath) {
      if (dialogDocumentsTable) {
        commit('setDialogCurrentFolderPath', folderPath)
      } else {
        commit('setCurrentFolderPath', folderPath)
      }
    }
  },
  setCurrentFolder({ commit }, { folder, dialogDocumentsTable }) {
    if (dialogDocumentsTable) {
      commit('setDialogCurrentFolder', folder)
    } else {
      commit('setCurrentFolder', folder)
    }
  },
  setMoveFileDialog({ state, commit }, { dialogState, file }) {
    commit('setCurrentFile', file)
    if (dialogState) {
      // Dialog table should open in same place as document table
      commit('setDialogNavigationFolderHistory', state.documentsTable.navigationFolderHistory)
      commit('setDialogCurrentFolder', state.documentsTable.currentFolder)
      commit('setDialogCurrentFolderPath', state.documentsTable.currentFolderPath)
    }
    commit('setMoveFileDialog', dialogState)
  },
  setCopyFileDialog({ commit, state }, { dialogState, file }) {
    commit('setCurrentFile', file)
    if (dialogState) {
      // Dialog table should open in same place as document table
      commit('setDialogNavigationFolderHistory', state.documentsTable.navigationFolderHistory)
      commit('setDialogCurrentFolder', state.documentsTable.currentFolder)
      commit('setDialogCurrentFolderPath', state.documentsTable.currentFolderPath)
    }
    commit('setCopyFileDialog', dialogState)
  },
  setDeleteFileDialog({ commit }, { dialogState, file }) {
    commit('setCurrentFile', file)
    commit('setDeleteFileDialog', dialogState)
  },
  setDuplicateFileDialog({ commit }, { dialogState, file }) {
    commit('setCurrentFile', file)
    commit('setDuplicateFileDialog', dialogState)
  },
  setRenameFileDialog({ commit }, { dialogState, file }) {
    commit('setCurrentFile', file)
    commit('setRenameFileDialog', dialogState)
  },
  setNavigationFolderHistory ({ commit }, { folder, dialogDocumentsTable }) {
    if (dialogDocumentsTable) {
      commit('setDialogNavigationFolderHistory', folder)
    } else {
      commit('setNavigationFolderHistory', folder)
    }
  },
  setBreadcrumbs({ commit, state }, dialogFolders) {
    let breadcrumbFolderPath = ''
    const currentFolderPath = (dialogFolders) ? state.dialogDocumentsTable.currentFolderPath : state.documentsTable.currentFolderPath
    const navigationFolderHistory = (dialogFolders) ? state.dialogDocumentsTable.navigationFolderHistory : state.documentsTable.navigationFolderHistory

    const breadcrumbNames = currentFolderPath.split('/').filter(dir => dir !== '')

    const formattedBreadcrumbs = breadcrumbNames.map((b, index) => {
      breadcrumbFolderPath += '/' + b
      const folder = navigationFolderHistory.find(f => f.path === breadcrumbFolderPath)
      const breadcrumbObj = (folder) ? Object.assign({}, folder) : {}

      breadcrumbObj.disabled = (index === breadcrumbNames.length - 1)
      breadcrumbObj.name = b
      return breadcrumbObj
    })
    const breadcrumbs = [{
      id: null,
      name: "Home",
      disabled: false,
      folderPath: '/'
    }].concat(formattedBreadcrumbs)

    if (dialogFolders) {
      commit('setDialogBreadcrumbs', breadcrumbs)
    } else {
      commit('setBreadcrumbs', breadcrumbs)
    }
  },
  documentTableNavigate ({ commit, state }, newFolderLocation) {
    // If folder not selected, then use current folder location
    const targetFolder = (state.currentFolderSelection) ? state.currentFolderSelection : state.dialogDocumentsTable.currentFolder
    commit('setNavigationFolderHistory', state.dialogDocumentsTable.navigationFolderHistory)
    commit('setCurrentFolder', targetFolder)
    commit('setCurrentFolderPath', newFolderLocation)
  },
  async navigateFromCase({ commit, state }, { caseId, path }) {
    try {
      const response = await provider.getBreadcrumbFolders(parseInt(caseId, 10), path)
      if (response) {
        const currentPath = `/${path}`
        const currentFolder = response.find(f => f.folderPath === currentPath)

        response.forEach(f => {
          const folder = Helpers.formatFolder(f)
          commit('setNavigationFolderHistory', folder)
        })
        if (state.documentsTable.currentFolderPath === currentPath) commit('setFoldersLoading', false)
        commit('setCurrentFolder', currentFolder)
        commit('setCurrentFolderPath', currentPath)
      } else {
        commit("displayFlashMessage", { message: "Error fetching case folders", severity: "error" })
      }
    } catch (err) {
      console.log(err)
      commit("displayFlashMessage", { message: err, severity: "error" })
    }
  },
  toggleFileSelection({ commit, state }, { file, allowSelectMultiple }) {
    const updatedSelections = Object.assign([], state.selectedAttachments)
    const targetIndex = updatedSelections.findIndex(a => a.id === file.id)
    const toggleAllowed = allowSelectMultiple || !file.selected || state.selectedAttachments.length < 1

    if (toggleAllowed) {
      if (file.selected) {
        if (targetIndex === -1) updatedSelections.push(file)
      } else {
        if (targetIndex !== -1) updatedSelections.splice(targetIndex, 1)
        commit('setAllFileCheckboxSelected', false)
      }
      commit("toggleFileSelection", updatedSelections)
    }
  },
  toggleFilesSelection({ commit, state }, { files, selected, allowSelectMultiple }) {
    const updatedSelections = Object.assign([], state.selectedAttachments)
    if (files && files.length) {
      files.forEach(file => {
        const targetIndex = updatedSelections.findIndex(a => a.id === file.id)
        if (selected) {
          if (targetIndex === -1) updatedSelections.push(file)
        } else {
          if (targetIndex !== -1) updatedSelections.splice(targetIndex, 1)
        }
      })
    }
    commit("toggleFileSelection", updatedSelections)
    commit('setAllFileCheckboxSelected', selected)
  },
  clearFileSelection({ commit }) {
    commit("clearFileSelection")
  },
  resetDocumentState({ commit, state }, isDialogDocumentsTable) {
    if (!isDialogDocumentsTable) {
      const triggerDocumentReload = state.documentsTable.currentFolderPath === '/'
      commit('setCurrentFolder', null)
      commit('setCurrentFolderPath', '/')
      commit('clearNavigationFolderHistory')
      return triggerDocumentReload
    }
  },
  setInitialLoadActionsComplete({ commit }, state) {
    commit('setInitialLoadActionsComplete', state)
  }
}
